import { ToastOptions } from 'react-toastify';

export const TOAST_AUTO_CLOSE_MS = {
  DEFAULT: 4000,
  SHORT: 2000,
} as const;

export const SHORT_SUCCESS_TOAST_OPTIONS: Readonly<ToastOptions> = {
  type: 'success',
  autoClose: TOAST_AUTO_CLOSE_MS.SHORT,
};
